<template>
  <div>
    <el-card>
      <el-row class="gala__title">庆典房活动配置</el-row>
      <!-- 搜索 -->
      <el-row class="gala__search">
        <span>申请状态：</span>
        <el-select v-model="status" filterable clearable placeholder="请选择" style="width: 150px">
          <el-option v-for="(item, index) in statusList" :key="index" :label="item.name" :value="item.value">
          </el-option>
        </el-select>
        <span>ID:</span>
        <el-input v-model="rid" style="width: 150px"></el-input>
        <el-button type="primary" style="margin-left: 10px" @click="getConfig(1)">搜索</el-button>
        <el-button type="primary" style="margin-left: 10px" @click="dialogVisible = true">添加</el-button>
      </el-row>
      <!-- 表格数据 -->
      <el-row>
        <el-table border :data="tableList">
          <el-table-column prop="applyTime" label="申请时间" align="center" :formatter="formatDate"></el-table-column>
          <el-table-column prop="startTime" label="开始时间" align="center" :formatter="formatDate"></el-table-column>
          <el-table-column prop="uid" label="用户uid" align="center">
          </el-table-column>
          <el-table-column prop="rid" label="用户rid" align="center">
          </el-table-column>
          <el-table-column label="申请类型" align="center">
            <template slot-scope="scope">
              {{
                galaRoomTypeEnumMap.find(
                  (item) => item.value == scope.row.roomType
                )?.name || ''
              }}
            </template>
          </el-table-column>
          <el-table-column prop="description" label="描述" align="center">
          </el-table-column>
          <el-table-column prop="title" label="活动标题" align="center">
          </el-table-column>
          <el-table-column label="活动状态" align="center">
            <template slot-scope="scope">
              {{
                statusList.find((item) => item.value == scope.row.approveStatus)
                  ?.name || '活动进行中'
              }}
            </template>
          </el-table-column>
          <el-table-column label="操作" align="center" width="200">
            <template slot-scope="scope">
              <el-row v-if="scope.row.approveStatus == 0"><el-button type="success"
                  @click="updateConfig(scope.row, 1)">通过</el-button>
                <el-button type="danger" @click="updateConfig(scope.row, 2)">拒绝</el-button></el-row>
            </template>
          </el-table-column>
        </el-table>
      </el-row>
      <!-- 分页 -->
      <el-pagination background layout="prev, pager, next" :total="total" :page-size="30" @current-change="changePage">
      </el-pagination>
      <!-- 弹窗 -->
      <el-dialog :visible.sync="dialogVisible" title="新增主题派对" @close="closes">
        <el-row>
          <span>用户id列表:</span>
          <el-button type="primary" @click="openAddRidDialog" style="margin-left: 10px">添加ID</el-button>
        </el-row>
        <el-row>
          <span>活动说明:</span>
          <el-input type="textarea" :autosize="{ minRows: 4 }" placeholder="请输入内容" v-model="info.description"
            style="margin-left: 20px; width: 330px">
          </el-input>
        </el-row>
        <el-row>
          <span>主题类型:</span>
          <el-select v-model="info.galaRoomType" filterable clearable placeholder="请选择"
            style="margin-left: 20px; width: 330px">
            <el-option v-for="(item, index) in galaRoomTypeEnumMap" :key="index" :label="item.name" :value="item.value">
            </el-option>
          </el-select>
        </el-row>
        <el-row>
          <span>开始时间:</span>
          <el-date-picker v-model="info.startTime" type="datetime" placeholder="选择日期时间" value-format="timestamp"
            style="margin-left: 20px">
          </el-date-picker>
        </el-row>
        <el-row>
          
          <el-popconfirm title="确定添加吗？" @confirm="addConfig">
            <el-button slot="reference" type="primary">确认</el-button>
          </el-popconfirm>
          <el-button @click="closes" style="margin-left: 10px">取消</el-button>
        </el-row>
      </el-dialog>
    </el-card>
    <el-card style="margin-top: 20px">
      <el-row class="gala__title">红包雨配置</el-row>
      <!-- 基本信息配置 -->
      <el-row class="gala__search">
        <span>红包雨等级:</span>
        <el-select v-model="redBagConfig.level" filterable clearable placeholder="请选择" style="width: 150px">
          <el-option v-for="(item, index) in levelList" :key="index" :label="item.name" :value="item.value">
          </el-option>
        </el-select>
        <el-button type="primary" style="margin-left: 10px" @click="getRedBagConfig(redBagConfig.level)">搜索</el-button>
        <el-button type="primary" style="margin-left: 10px" @click="changeRedBagConfig()">修改</el-button>
        <el-button type="primary" style="margin-left: 10px" @click="redDialogVisible = true">新增红包配置</el-button>
      </el-row>
      <el-row class="gala__search">
        <span>下降速度:</span>
        <el-input-number v-model="redBagConfig.fallSpeed" :step="1" step-strictly :max="5" :min="1"></el-input-number>
        <span>最大获得奖励数:</span>
        <el-input-number v-model="redBagConfig.ipMaxClaim"></el-input-number>
        <span>红包雨持续时间(s):</span>
        <el-input-number v-model="redBagConfig.fallDuration"></el-input-number>
      </el-row>
      <!-- 表格数据 -->
      <el-row>
        <el-table border :data="redBagConfig.rewards">
          <el-table-column label="红包类型" align="center">
            <template slot-scope="scope">
              {{
                redBagType.find(
                  (item) => item.value == scope.row.redEnvelopType
                )?.name || ''
              }}
            </template>
          </el-table-column>
          <el-table-column prop="hitRate" label="中奖率" align="center">
          </el-table-column>
          <el-table-column prop="redEnvelopNum" label="红包数量" align="center">
          </el-table-column>
          <el-table-column prop="rewardNum" label="配置奖品数量" align="center">
          </el-table-column>
          <el-table-column label="图标" align="center">
            <template slot-scope="scope">
              <el-image style="width: 100px; height: auto" :src="scope.row.awardData.icon"
                :preview-src-list="[scope.row.awardData.bigIcon]"></el-image>
            </template>
          </el-table-column>
          <el-table-column label="操作" align="center">
            <template slot-scope="scope">
              <el-button type="primary" @click="deletes(scope.$index)">删除</el-button>
            </template>
          </el-table-column>
        </el-table>
      </el-row>
      <el-dialog :visible.sync="redDialogVisible" title="新增红包配置" @close="cancel">
        <el-row>
          <span>红包类型:</span>
          <el-select v-model="redConfig.redEnvelopType" filterable clearable placeholder="请选择"
            style="width: 150px; margin-left: 10px">
            <el-option v-for="(item, index) in redBagType" :key="index" :label="item.name" :value="item.value">
            </el-option>
          </el-select>
        </el-row>
        <el-row>
          <span>概率:</span>
          <el-input type="number" placeholder="请输入" v-model="redConfig.hitRate" style="margin-left: 20px; width: 200px">
          </el-input>
        </el-row>
        <el-row>
          <span>红包数量:</span>
          <el-input type="number" placeholder="请输入" v-model="redConfig.redEnvelopNum"
            style="margin-left: 20px; width: 200px">
          </el-input>
        </el-row>
        <el-row>
          <span>配奖品数量:</span>
          <el-input type="number" placeholder="请输入" v-model="redConfig.rewardNum"
            style="margin-left: 20px; width: 200px">
          </el-input>
        </el-row>
        <el-row>
          <!-- <span>奖品id:</span>
          <el-input
            type="number"
            placeholder="请输入"
            v-model="redConfig.awardData.id"
            style="margin-left: 20px; width: 200px"
          >
          </el-input> -->
          <el-button type="primary" @click="innerDialogVisible = true">礼物选择</el-button>
        </el-row>
        <el-row>
          <el-button type="primary" @click="addRedConfig">确认</el-button>
          <el-button @click="cancel">取消</el-button>
        </el-row>
      </el-dialog>
      <el-dialog :visible.sync="innerDialogVisible" title="礼物选择" @close="closes">
        <el-table :data="rewardList" highlight-current-row style="width: 100%" @current-change="handleCurrentChange">
          <el-table-column property="id" label="id" width="120">
          </el-table-column>
          <el-table-column label="图标" align="center">
            <template slot-scope="scope">
              <el-image style="width: 100px; height: auto" :src="scope.row.icon"
                :preview-src-list="[scope.row.bigIcon]"></el-image>
            </template>
          </el-table-column>
        </el-table>
        <!-- 分页 -->
        <el-pagination background layout="prev, pager, next" :total="totals" :page-size="30"
          @current-change="changeRedPage">
        </el-pagination>
      </el-dialog>
    </el-card>
    <!-- ID添加弹窗 -->
    <el-dialog :visible.sync="ridDialogVisible" title="添加用户ID" append-to-body>
      <el-row style="margin-top: 20px">
        <el-input type="text" placeholder="请输入用户ID" v-model="tempRid" style="width: 200px">
        </el-input>
        <el-button type="primary" @click="addTempRid" style="margin-left: 10px">添加</el-button>
      </el-row>

      <el-row style="margin-top: 20px">
        <el-table border :data="tempRidList" style="width: 100%">
          <el-table-column prop="rid" label="用户ID" align="center"></el-table-column>
          <el-table-column label="操作" align="center" width="100">
            <template slot-scope="scope">
              <el-button type="danger" size="mini" @click="deleteTempRid(scope.$index)">删除</el-button>
            </template>
          </el-table-column>
        </el-table>
      </el-row>

      <el-row style="margin-top: 20px; text-align: right;">
        <el-button type="primary" @click="confirmRidList">确认</el-button>
        <el-button @click="cancelRidDialog">取消</el-button>
      </el-row>
    </el-dialog>
  </div>
</template>

<script>
export default {
  data() {
    return {
      rid: null,
      status: null,
      statusList: [
        {
          name: '全部',
          value: null,
        },
        {
          name: '未审批',
          value: 0,
        },
        {
          name: '通过',
          value: 1,
        },
        {
          name: '拒绝',
          value: 2,
        },
        {
          name: '活动进行未开始',
          value: 3,
        },
        {
          name: '活动进行中',
          value: 4,
        },
        {
          name: '活动结束',
          value: 5,
        },
        {
          name: '活动逾期',
          value: 6,
        },
      ],
      info: {
        ridList: [],
        description: null,
        galaRoomType: null,
        startTime: null,
      },
      tempRid: '',
      galaRoomTypeEnumMap: [
        { name: 'BIRTHDAY', value: 1 },
        { name: 'LOVE', value: 2 },
        { name: 'ANNIVERSARY', value: 3 },
        { name: 'AGENCY', value: 4 },
        { name: 'POPULARITY', value: 5 },
      ],
      //   红包雨等级
      levelList: [
        {
          name: '初级',
          value: 1,
        },
        {
          name: '中级',
          value: 2,
        },
        {
          name: '高级',
          value: 3,
        },
      ],
      status: [],
      //   红包类型
      redBagType: [
        {
          name: '等额金币红包',
          value: 1,
        },
        {
          name: '随机金币红包',
          value: 2,
        },
        {
          name: '礼物红包',
          value: 3,
        },
      ],
      redBagConfig: {
        level: 1,
        fallSpeed: 1,
        ipMaxClaim: null,
        fallDuration: null,
        rewards: [
          {
            redEnvelopType: null,
            hitRate: null,
            redEnvelopNum: null,
            rewardNum: null,
            awardData: {
              id: null,
            },
          },
        ],
      },
      redConfig: {
        redEnvelopType: null,
        hitRate: null,
        redEnvelopNum: null,
        rewardNum: null,
        awardData: {
          id: null,
        },
      },
      rewardList: [],
      redDialogVisible: false,
      dialogVisible: false,
      innerDialogVisible: false,
      tableList: [],
      currentPage: 1,
      redPage: 1,
      total: 10,
      totals: 10,
      ridDialogVisible: false,
      searchRid: '',
      tempRidList: [], // 临时存储用户ID的数组
    }
  },
  computed: {
    // 获取过滤后的ID列表
    filteredRidList() {
      if (!this.searchRid) {
        return this.tempRidList;
      }

      return this.tempRidList.filter(item => item.rid.includes(this.searchRid));
    },
  },
  mounted() {
    this.getConfig()
    this.getRedBagConfig(1)
  },
  methods: {
    changeTime(val) {
      this.info.startTime = val / 1000
    },
    changePage(page) {
      this.currentPage = page
      this.getConfig()
    },
    changeRedPage(page) {
      this.redPage = page
      this.getRedBagConfig(this.redConfig.level)
    },
    addRedConfig() {
      const infos = JSON.parse(JSON.stringify(this.redBagConfig))
      infos.rewards = infos.rewards || []
      infos.rewards.push(this.redConfig)
      this.changeRedBagConfig(infos)
    },
    cancel() {
      this.redConfig = {
        redEnvelopType: null,
        hitRate: null,
        redEnvelopNum: null,
        rewardNum: null,
        awardData: {
          id: null,
        },
      }
      this.redDialogVisible = false
    },
    // 删除红包配置
    deletes(index) {
      this.redBagConfig.rewards.splice(index, 1)
      this.changeRedBagConfig()
    },
    // 获取配置列表
    async getConfig(page) {
      if (page) {
        this.currentPage = page
      }
      const { data: res } = await this.$axios({
        method: 'GET',
        withCredentials: true,
        headers: {
          'Content-Type': 'application/json; charset=UTF-8',
        },
        url: this.$store.getters.path.gala_type_query,
        params: {
          username: this.$store.getters.username,
          token: this.$store.getters.token,
          approveStatus: this.status,
          page: this.currentPage,
          rid: +this.rid,
        },
      })
      if (res.code !== 0) {
        return this.$message.error(res.msg)
      } else {
        this.tableList = res.data.data
        this.total = res.data.total
      }
    },
    handleCurrentChange(val) {
      console.log(val)
      this.redConfig.awardData = val
      this.innerDialogVisible = false
    },
    // 获取红包配置
    async getRedBagConfig(level) {
      console.log(level)
      const { data: res } = await this.$axios({
        method: 'GET',
        withCredentials: true,
        headers: {
          'Content-Type': 'application/json; charset=UTF-8',
        },
        url: this.$store.getters.path.gala_redBag_query,
        params: {
          username: this.$store.getters.username,
          token: this.$store.getters.token,
          level,
          page: this.redPage,
        },
      })
      if (res.code !== 0) {
        return this.$message.error(res.msg)
      } else {
        this.redBagConfig = res.data
        this.rewardList = res.data.awardList?.data
        console.log(this.rewardList)
        this.totals = res.data.awardList.total
      }
    },
    // 修改红包配置
    async changeRedBagConfig(info) {
      let data
      if (info) {
        data = info
      } else {
        data = this.redBagConfig
      }
      const { data: res } = await this.$axios({
        method: 'POST',
        withCredentials: true,
        headers: {
          'Content-Type': 'application/json; charset=UTF-8',
        },
        url: this.$store.getters.path.gala_redBag_update,
        params: {
          username: this.$store.getters.username,
          token: this.$store.getters.token,
        },
        data,
      })
      if (res.code !== 0) {
        return this.$message.error(res.msg)
      } else {
        this.$message.success('修改成功')
        this.getRedBagConfig(this.redBagConfig.level)
        this.cancel()
      }
    },
    // 添加配置
    async addConfig() {
      const data = JSON.parse(JSON.stringify(this.info))
      data.startTime = data.startTime / 1000

      if (data.ridList.length === 0) {
        return this.$message.warning('请至少添加一个用户ID');
      }

      const { data: res } = await this.$axios({
        method: 'POST',
        withCredentials: true,
        headers: {
          'Content-Type': 'application/json; charset=UTF-8',
        },
        url: this.$store.getters.path.gala_add,
        params: {
          username: this.$store.getters.username,
          token: this.$store.getters.token,
        },
        data,
      })
      if (res.code !== 0) {
        return this.$message.error(res.msg)
      } else {
        this.$message.success('添加成功')
        this.closes()
        this.getConfig()
        this.dialogVisible = false
      }
    },
    // 审批
    async updateConfig(infos, status) {
      const { data: res } = await this.$axios({
        method: 'POST',
        withCredentials: true,
        headers: {
          'Content-Type': 'application/json; charset=UTF-8',
        },
        url: this.$store.getters.path.gala_update,
        params: {
          username: this.$store.getters.username,
          token: this.$store.getters.token,
        },
        data: {
          id: infos.id,
          uid: infos.uid,
          approveStatus: status,
        },
      })
      if (res.code !== 0) {
        return this.$message.error(res.msg)
      } else {
        this.$message.success('审批成功')
        this.getConfig()
      }
    },
    closes() {
      this.dialogVisible = false
      this.tempRid = ''
      this.info = {
        ridList: [],
        description: null,
        galaRoomType: null,
        startTime: null,
      }
    },
    // 格式化时间
    formatDate(row, column) {
      // 获取单元格数据
      let data = row[column.property] * 1000
      console.log('-=-=-=-=-=')
      console.log(data)
      if (data == null) {
        return null
      }
      let dt = new Date(data)
      return (
        dt.getFullYear() +
        '-' +
        (dt.getMonth() + 1) +
        '-' +
        dt.getDate() +
        ' ' +
        dt.getHours() +
        ':' +
        dt.getMinutes() +
        ':' +
        dt.getSeconds()
      )
    },
    // 打开添加ID弹窗
    openAddRidDialog() {
      this.tempRidList = JSON.parse(JSON.stringify(this.info.ridList || []));
      this.tempRidList = this.tempRidList.map(item => {
        return {
          rid: item,
        }
      })
      this.searchRid = '';
      this.ridDialogVisible = true;
    },

    // 搜索ID列表
    searchRidList() {
      // 这里可以实现搜索逻辑，目前简单过滤本地数据
      this.searchRid = this.searchRid.trim();
    },

    // 添加用户ID到临时列表
    addTempRid() {
      if (!this.tempRid) {
        return this.$message.warning('请输入用户ID');
      }

      const ridsToAdd = this.tempRid.split(',').map(rid => rid.trim()).filter(rid => rid !== '');

      if (ridsToAdd.length === 0) {
        return this.$message.warning('请输入有效的用户ID');
      }

      let addedCount = 0;
      let duplicateCount = 0;

      ridsToAdd.forEach(rid => {
        // 检查是否已存在相同ID
        const exists = this.tempRidList.some(item => item.rid === rid);
        if (exists) {
          duplicateCount++;
        } else {
          this.tempRidList.push({ rid: rid });
          addedCount++;
        }
      });

      this.tempRid = ''; // 清空输入框

      let message = '';
      if (addedCount > 0) {
        message += `成功添加 ${addedCount} 个用户ID。`;
      }
      if (duplicateCount > 0) {
        message += `${duplicateCount} 个用户ID已存在。`;
      }
      if (message) {
         this.$message.success(message.trim());
      }
    },

    // 从临时列表删除用户ID
    deleteTempRid(index) {
      this.tempRidList.splice(index, 1);
    },

    // 确认ID列表，更新到info.ridList
    confirmRidList() {
      this.info.ridList = this.tempRidList.length > 0 ? this.tempRidList.map(item => item.rid) : [];
      this.ridDialogVisible = false;
      this.$message.success('用户ID列表已更新');
    },

    // 取消ID添加弹窗
    cancelRidDialog() {
      this.ridDialogVisible = false;
      this.tempRidList = [];
      this.searchRid = '';
      this.tempRid = '';
    },
  },
}
</script>
<style scoped lang="scss">
.gala {
  &__title {
    font-size: 28px;
    font-weight: 700;
    margin-bottom: 20px;
  }

  &__search {
    span {
      font-size: 20px;
      font-weight: 600;
      margin-right: 15px;
      margin-left: 15px;
    }

    .searchBtn {
      margin-left: 10px;
    }
  }
}
</style>